module.exports = __webpack_public_path__ + "img/male_accountant.23b4cf4b.svg";